module.exports = __webpack_public_path__ + "media/images/flags/1x1/cok-6ca83b2605ab10904553834aa09005ea.svg";